import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import styles from './StructureDropdown.module.scss';

type Status = 'good' | 'average' | 'bad';

interface Goal {
  goal: number;
  min: number;
  max: number;
}

export interface StructureDropdownProps {
  name: string;
  statGoal: Goal;
  value: number;
  selected?: boolean;
  onClickDropdown?(): void;
  comment: string;
  indicatorName?: string;
}

function StructureDropdown({
  name,
  statGoal,
  value,
  selected,
  comment,
  indicatorName,
  onClickDropdown,
}: StructureDropdownProps): JSX.Element {
  const status: Status = getStatus();

  function getStatus(): Status {
    const {max, min, goal} = statGoal;

    const limit = value > goal ? max : min;

    const score =
      value === goal ? 1 : ((limit - goal) * 0.1659) / (value - goal);

    // If the 'score' is less to 61% then bar is red, or
    // If the 'score' is less to 1% and up to 61% then bar is yellow, or
    // If the 'score' is less to 1% then bar is green

    // score = ((0% - 100%) * 0.1659) / (21% - 100%) = 0.21
    if (score < 0.21) {
      return 'bad';
    }

    // score = ((0% - 100%) * 0.1659) / (61% - 100%) = 0.425
    if (score < 0.425) {
      return 'average';
    }

    return 'good';
  }

  function getEmoji() {
    if (status === 'bad') {
      return <FontAwesomeIcon icon="face-frown-slight" color="#E94B56" />;
    }
    if (status === 'good') {
      return <FontAwesomeIcon icon="face-laugh-beam" color="#2FAC66" />;
    }
    return <FontAwesomeIcon icon="face-meh" color="#F3AF31" />;
  }

  function getGoalText() {
    if (status === 'bad') {
      return 'Fora da meta';
    }
    if (status === 'good') {
      return 'Dentro da meta';
    }
    return 'Próximo à meta';
  }

  return (
    <button
      className={styles.wrapper}
      key={indicatorName}
      type="button"
      onClick={onClickDropdown}
      data-testid={`dropbutton-${name.toLowerCase()}`}
    >
      <div className={styles.wrapperHeader}>
        <p>{name}</p>

        <b>
          {getEmoji()} {getGoalText()}
        </b>

        <FontAwesomeIcon
          icon={!selected ? 'chevron-down' : 'chevron-up'}
          color="#4574B9"
        />
      </div>
      {selected && (
        <div className={styles.comment}>
          <div className={styles.commentGoal}>
            <b>Meta de {name.toLowerCase()}</b>
            <p>
              <b>{value}/</b>
              {statGoal.goal}
            </p>
          </div>

          <div className={styles.commentBox}>
            <b>O que são {name.toLowerCase()}?</b>
            <div dangerouslySetInnerHTML={{__html: comment}} />
          </div>
        </div>
      )}
    </button>
  );
}

export default StructureDropdown;
